import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { SrIcon } from "@/components/ui/SrIcon";
import type { DBEquipmentCategory } from "@/lib/db-types";

interface CategoryMultiFilterProps {
  categories: DBEquipmentCategory[];
  selected: string[];
  onChange: (ids: string[]) => void;
}

/** Flervalg av kategorier. Tomt utvalg betyr alle. */
export function CategoryMultiFilter({ categories, selected, onChange }: CategoryMultiFilterProps) {
  const names = categories.filter((c) => selected.includes(c.id)).map((c) => c.name);
  const label = names.length === 0 ? "Alle kategorier" : names.join(", ");
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="max-w-[260px]" aria-label={`Kategori: ${label}`}>
          <SrIcon name="filter" className="h-4 w-4" />
          <span className="truncate">{label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {categories.map((c) => (
          <DropdownMenuCheckboxItem
            key={c.id}
            checked={selected.includes(c.id)}
            onSelect={(e) => e.preventDefault()}
            onCheckedChange={(on) => onChange(on ? [...selected, c.id] : selected.filter((id) => id !== c.id))}
          >
            {c.name}
          </DropdownMenuCheckboxItem>
        ))}
        {selected.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => onChange([])}>Vis alle</DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
